import { getJsonOrError } from '../../utils/fetch'
import { queryString } from '../../utils/window'
import { getApiServicesEndpoints } from '../../application/pageDataObject'

function getDate(localTime) {
  const date = queryString.localTime
    ? new Date(queryString.localTime)
    : new Date(localTime.getTime() - localTime.getTimezoneOffset() * 60000)
  date.setSeconds(0, 0)
  return date
}

export async function getCampaignsFromCampaignManagerService(site, country, localTime) {
  const result = await getJsonOrError(
    `${getApiServicesEndpoints().campaigns}?site=${site}&country=${country}&localTime=${getDate(
      localTime
    ).toJSON()}`
  )
  return result.data
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/campaignManager/campaignManagerProvider.js